/**
 * Nextcloud Cookbook app
 * Vue frontend entry file
 * ---------------------------
 * @license AGPL3 or later
 */

/// <reference types="@nextcloud/typings" />

import Vue from 'vue';
import { createPinia, PiniaVuePlugin } from 'pinia';

import { useLegacyStore } from './store';

import AppInvalidGuest from './components/AppInvalidGuest.vue';

declare global {
	interface Window {
		OC:
			| Nextcloud.v16.OC
			| Nextcloud.v17.OC
			| Nextcloud.v18.OC
			| Nextcloud.v19.OC
			| Nextcloud.v20.OC;
		n: string;
		t: string;
	}
}

Vue.config.devtools = import.meta.env.MODE === 'development';

// Also make the injections available in Vue components
Vue.prototype.OC = window.OC;

// Pass translation engine to Vue
Vue.prototype.t = window.t;
Vue.prototype.n = window.n;

Vue.use(PiniaVuePlugin);
const pinia = createPinia();

// Start the app once document is done loading
const App = Vue.extend(AppInvalidGuest);
new App({
	// router,
	pinia,
	beforeCreate() {
		const legacyStore = useLegacyStore();
		legacyStore.refreshConfig();
		legacyStore.initializeStore();
	},
}).$mount('#content');
